module.exports = __webpack_public_path__ + "img/N550-2.7b0cad86.png";